import { MutableRefObject, useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { useMapCenter } from '../../fields-preview/utils/map';
import { CONUS_CENTER_COORDS } from '../../../constants/coords';

interface LandAdvisorMapState {
  mapRef: MutableRefObject<mapboxgl.Map | null>;
  mapLoaded: boolean;
  setMapLoaded: (mapLoaded: boolean) => void;
  mapCenter: { lng: number; lat: number };
}

const useLandAdvisorMapState = (zoom: number): LandAdvisorMapState => {
  const mapRef = useRef<mapboxgl.Map | null>(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const mapCenter = useMapCenter(mapLoaded, mapRef) as [number, number];
  const [lng = 0, lat = 0] = mapCenter;

  useEffect(() => {
    const map = mapRef.current;
    if (!mapLoaded || !map) return;
    const canvas = map.getCanvas();
    if (canvas) {
      canvas.style.outline = 'none'; // Remove focus outline on map
    }
    // Recenter map if valid mapCenter is provided
    if (mapCenter && lng && lat && mapCenter !== CONUS_CENTER_COORDS) {
      map.setCenter([mapCenter[0], mapCenter[1]]);
      map.setZoom(zoom);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapLoaded]);

  return {
    mapRef,
    mapLoaded,
    setMapLoaded,
    mapCenter: { lng, lat },
  };
};

export default useLandAdvisorMapState;
